import { Component, ElementRef, HostListener, Input, ViewChild, inject } from '@angular/core';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { MaintenanceTimelineRow } from '../../../models/asset-details-response.model';
import { CommonModule, formatDate } from '@angular/common';
import { InlineEmptyStateComponent } from '../../../../../_shared/components/states/inline-empty-state/inline-empty-state.component';

@Component({
  selector: 'app-maintenance-timeline-row',
  standalone: true,
  imports: [CommonModule, NgbTooltipModule, InlineEmptyStateComponent, TranslocoDirective],
  templateUrl: './maintenance-timeline-row.component.html',
  styleUrl: './maintenance-timeline-row.component.scss'
})
export class MaintenanceTimelineRowComponent {
  private readonly transloco: TranslocoService = inject(TranslocoService);

  @ViewChild('chipsScroller') chipsScroller!: ElementRef<HTMLDivElement>;

  @Input() item: MaintenanceTimelineRow;

  showLeftArrow = false;
  showRightArrow = false;

  getStatusDate(): string {
    if (!this.item.statusDate) {
      return '-';
    }

    const formattedDate = formatDate(this.item.statusDate, 'dd MMM yyyy', 'en-US');
    return this.item.showDuePrefix
      ? this.transloco.translate('assetOverview.timeline.due', { date: formattedDate })
      : formattedDate;
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.updateArrows());
  }

  @HostListener('window:resize')
  onResize(): void { setTimeout(() => this.updateArrows()); }

  onChipsScroll(event?: Event) {
    const element = (event?.target as HTMLElement) || this.chipsScroller?.nativeElement;
    if (!element) return;

    this.updateArrows();
  }

  scrollChips(direction: 1 | -1) {
    const element = this.chipsScroller?.nativeElement;
    if (!element) return;

    const amount = Math.max(120, Math.floor(element.clientWidth * 0.8));
    element.scrollBy({ left: direction * amount, behavior: 'smooth' });

    setTimeout(() => this.updateArrows());
  }

  private updateArrows() {
    const element = this.chipsScroller?.nativeElement;
    if (!element) return;

    const max = element.scrollWidth - element.clientWidth;
    const left = element.scrollLeft;

    this.showLeftArrow  = left > 0;
    this.showRightArrow = max > 0 && left < max - 1;
  }
}